import React, { useContext, useEffect, useState } from "react";
import styled, { css } from "styled-components";
import FormDataContext from "integrations/contexts/FormDataContext";
import KeySecret from "integrations/aws/authentication/KeySecret";
import Automatic from "integrations/aws/authentication/Automatic";
import { Input } from "components/bootstrap";
import AppConfig from "util/AppConfig";
export const AWS_AUTH_TYPES = {
  automatic: "Automatic",
  keysecret: "Key & Secret"
};
const AuthWrapper = styled.div(
  ({ theme }) => css`
    margin: 0 0 21px 9px;
    padding: 3px 0 3px 21px;
    border-left: 3px solid ${theme.colors.gray[80]};
  `
);
const AWSAuthenticationTypes = ({ onChange }) => {
  const { clearField, formData } = useContext(FormDataContext);
  const { awsAuthenticationType, awsAccessKey, awsSecretKey } = formData;
  let defaultAuthTypeValue;
  if (AppConfig.isCloud()) {
    defaultAuthTypeValue = AWS_AUTH_TYPES.keysecret;
  } else {
    defaultAuthTypeValue = awsAuthenticationType ? awsAuthenticationType.value : AWS_AUTH_TYPES.automatic;
  }
  const [currentType, setCurrenType] = useState(defaultAuthTypeValue);
  useEffect(() => {
    onChange({ target: { name: "awsAuthenticationType", value: defaultAuthTypeValue } });
  }, []);
  const isType = (type) => currentType === type;
  const handleTypeChange = (e) => {
    setCurrenType(e.target.value);
    onChange({ target: { name: "awsAuthenticationType", value: e.target.value } });
    if (isType(AWS_AUTH_TYPES.automatic)) {
      clearField("awsAccessKey");
      clearField("awsSecretKey");
    }
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, AppConfig.isCloud() ? /* @__PURE__ */ React.createElement(KeySecret, { awsKey: awsAccessKey, awsSecret: awsSecretKey, onChange }) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "select",
      name: "awsAuthType",
      id: "awsAuthType",
      onChange: handleTypeChange,
      label: "AWS Authentication Type",
      defaultValue: currentType
    },
    Object.keys(AWS_AUTH_TYPES).map((type) => /* @__PURE__ */ React.createElement("option", { value: AWS_AUTH_TYPES[type], key: `option-${type}` }, AWS_AUTH_TYPES[type]))
  ), /* @__PURE__ */ React.createElement(AuthWrapper, null, isType(AWS_AUTH_TYPES.automatic) && /* @__PURE__ */ React.createElement(Automatic, null), isType(AWS_AUTH_TYPES.keysecret) && /* @__PURE__ */ React.createElement(KeySecret, { awsKey: awsAccessKey, awsSecret: awsSecretKey, onChange }))));
};
export default AWSAuthenticationTypes;
